import api from './api';

export interface Permissao {
  id: number;
  acao: string;
  entidade: string;
  descricao: string;
}

const listarPermissoes = async (): Promise<Permissao[]> => {
  const response = await api.get<Permissao[]>('/permissoes');
  return response.data;
};

export const permissaoService = {
  listarPermissoes,
};